import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AboutUsContent from "@/pages/AboutUsContent";

export const ABOUT_TITLE = "About WorkingBees Global | Recruitment Firm in India";
export const ABOUT_DESCRIPTION = "WorkingBees Global is a trusted recruitment firm and staffing agency in India, delivering IT, non-IT and bulk hiring solutions for businesses across India and globally.";
export const ABOUT_URL = "https://workingbees.net/about-us";
const HOME_TITLE = "Recruitment Firm in India | WorkingBees Global Staffing and Hiring";
const HOME_DESCRIPTION = "WorkingBees Global is a recruitment firm in India offering staffing, bulk hiring, candidate placement, HR consulting and AI IT services for employers and job seekers.";
const HOME_URL = "https://workingbees.net/";

const headFields = [
  ["meta", 'meta[name="description"]', "content", ABOUT_DESCRIPTION],
  ["link", 'link[rel="canonical"]', "href", ABOUT_URL],
  ["meta", 'meta[property="og:title"]', "content", ABOUT_TITLE],
  ["meta", 'meta[property="og:description"]', "content", ABOUT_DESCRIPTION],
  ["meta", 'meta[property="og:url"]', "content", ABOUT_URL],
  ["meta", 'meta[property="og:image"]', "content", "https://workingbees.net/logo.png"],
  ["meta", 'meta[name="twitter:title"]', "content", ABOUT_TITLE],
  ["meta", 'meta[name="twitter:description"]', "content", ABOUT_DESCRIPTION],
  ["meta", 'meta[name="twitter:image"]', "content", "https://workingbees.net/logo.png"],
];
const homeValues = [HOME_DESCRIPTION, HOME_URL, "Recruitment Firm in India | WorkingBees Global", "WorkingBees Global provides recruitment, staffing, bulk hiring, candidate placement, HR consulting and AI IT services across India and global markets.", HOME_URL, "https://workingbees.net/logo.png", "Recruitment Firm in India | WorkingBees Global", "Recruitment, staffing, bulk hiring, candidate placement and AI IT consulting services for employers and job seekers.", "https://workingbees.net/logo.png"];

export default function AboutUsPage() {
  useEffect(() => {
    const startedOnAbout = document.title === ABOUT_TITLE;
    const oldTitle = startedOnAbout ? HOME_TITLE : document.title;
    const previous = headFields.map(([tag, selector, attribute, value], index) => {
      let element = document.head.querySelector(selector);
      const existed = Boolean(element);
      if (!element) {
        element = document.createElement(tag);
        if (tag === "link") element.setAttribute("rel", "canonical");
        else if (selector.includes("property=")) element.setAttribute("property", selector.match(/property="([^"]+)/)[1]);
        else element.setAttribute("name", selector.match(/name="([^"]+)/)[1]);
        document.head.appendChild(element);
      }
      const oldValue = startedOnAbout ? homeValues[index] : element.getAttribute(attribute);
      element.setAttribute(attribute, value);
      return { element, attribute, oldValue, existed };
    });
    document.title = ABOUT_TITLE;
    return () => {
      document.title = oldTitle;
      previous.forEach(({ element, attribute, oldValue, existed }) => {
        if (!existed) element.remove();
        else if (oldValue === null) element.removeAttribute(attribute);
        else element.setAttribute(attribute, oldValue);
      });
    };
  }, []);

  return <><Navbar /><AboutUsContent initialTestimonials={window.__ABOUT_TESTIMONIALS__ || []} /><Footer /></>;
}
